import { usageUnitInventoryQuantityValueGetter } from '../valueGetter'

const UsageUnitInventoryQuantityRenderer = (props) => {
  return usageUnitInventoryQuantityValueGetter(props)
}

export default UsageUnitInventoryQuantityRenderer
